module.exports = __webpack_public_path__ + "img/IMG_5g.e6c8acea.jpg";